import { CashierItemModel } from './cashierItem.model';

export class PaymentQrModel {
  cashierCode: number;
  branchOfficeCode: number;
  expirationTime: Date;
  items: CashierItemModel[];
  reference: string;

  constructor() {
    this.cashierCode = 0;
    this.expirationTime = null;
    this.items = [];
    this.reference = '';
    this.branchOfficeCode = 0;
  }
}
